interface Props { className?: string; mood?: string }

export function PixelKitty({ className = "", mood }: Props) {
  return <div className={`kitty ${className}`} aria-label="Pixelová Hello Kitty" role="img">
    <div className="kitty__body">
      <img src="/assets/kitty-pixel.png" alt="" />
      <span className="kitty__eyes" aria-hidden="true"><i /><i /></span>
    </div>
    {mood && <p className="kitty__bubble" aria-live="polite">{mood}</p>}
  </div>;
}
